module.exports = __webpack_public_path__ + "img/shift-icon.43a59150.jpeg";